import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-white text-navy" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3mjq27fl7ksv2" />
      <main data-id="element-2" data-mp="3mj6hjr46bqdc">
        <Hero data-id="element-3" data-mp="3rc9co3oln7vn" />
        <SocialProof data-id="element-4" data-mp="3rbrayrj641gc" />
        <Testimonials data-id="element-5" data-mp="3rdatkosaqola" />
        <ProblemSection data-id="element-6" data-mp="3rd1a7k1rbfok" />
        <SystemSection data-id="element-7" data-mp="5yk6vxnnffx" />
        <ModulesSection data-id="element-8" data-mp="6hq1ea16ddl" />
        <BonusSection data-id="element-9" data-mp="4n5i12o8na1" />
        <UrgencySection data-id="element-10" data-mp="56qjqnmbrsa" />
        <PricingSection data-id="element-11" data-mp="2zl3brl12165b" />
        <MoreResults data-id="element-12" data-mp="2zlv7cvunj3vl" />
        <GuaranteeSection data-id="element-13" data-mp="2zmenc70qri6z" />
        <FAQ data-id="element-14" data-mp="2zn6bwxvx8fnr" />
        <ClosingSection data-id="element-15" data-mp="33mou3lwcycmw" />
        <SummaryTable data-id="element-16" data-mp="33m5eibu6k0c1" />
        <FinalCta data-id="element-17" data-mp="33ngee0ki8nxv" />
      </main>
      <Footer data-id="element-18" data-mp="33orki71fa7s5" />
      <PurchaseNotification data-id="element-19" data-mp="38lro8basuyg3" />
    </div>;
}